import store from '@/store'
export default [
  {
    path: '/levels',
    name: 'level',
    meta: { requiresAuth: true },
    component: () => import('@/pages/level/index-v2.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('level/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/levels/:id',
    name: 'level-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/level/index.vue'),
    props: route => ({ editData: route.params.editData }),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('level/dataBeforeCreate')
      let response = await store.dispatch('level/find', to.params.id)
      let { ...resource } = response.data
      to.params.editData = resource
      next()
    }
  }
]
